import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../firebase';
import { logEvent } from 'firebase/analytics';

export default function PageViewTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!analytics) return;
    try {
      logEvent(analytics, 'page_view', {
        page_location: window.location.href,
        page_path: pathname + search,
        page_title: document.title || pathname,
      });
    } catch (_) {}
  }, [pathname, search]);
  return null;
}


